import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_adminLayout/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/areas' });
  }
});
